export default __webpack_public_path__ + "static/media/ShoppingBag.0f9f5f13.png";